export const basicAbility = [
  {
    action: 'read',
    subject: 'core'
  }
]

export const acquireAbility = [
  {
    action: 'read',
    subject: 'acquire'
  },
  {
    action: 'read',
    subject: 'data'
  }
]

export const superAdmin = [
  {
    action: 'manage',
    subject: 'all'
  }
]

// The exchange rates (menu of the currency, rate.html) : given by each of the four administration rights
// (Adm, Acqu, Ref, Conf)
export const ratesAbility = [
  {
    action: 'update',
    subject: 'rates'
  }
]

// « Gestion des utilisateurs » (Adm) : the Users screen
export const adminAbility = [
  {
    action: 'update',
    subject: 'users'
  },
  {
    action: 'create',
    subject: 'user'
  }
]

// « Référentiel » (Ref) : the Repositories screen
export const repositoryAbility = [
  {
    action: 'update',
    subject: 'repository'
  }
]

// « Configuration » (Conf) : the Configuration screen and the general settings
export const configurationAbility = [
  {
    action: 'update',
    subject: 'settings'
  }
]

// « Accès au support » (Sup) : the "Report an issue" icon of the top bar (NavbarSupport). Unlike the other
// administration rights, it does not give the exchange rates
export const supportAbility = [
  {
    action: 'read',
    subject: 'support'
  }
]

export const analyticAbility = [
  {
    action: 'read',
    subject: 'analytic'
  },
  {
    action: 'create',
    subject: 'analytic'
  }
]

export const forecastAbility = [
  {
    action: 'read',
    subject: 'forecast'
  },
  {
    action: 'create',
    subject: 'forecast'
  }
]

export const employeesAbility = [
  {
    action: 'read',
    subject: 'employees'
  },
  {
    action: 'read',
    subject: 'data'
  }
]

export const budgetAbility = [
  {
    action: 'read',
    subject: 'budget'
  },
  {
    action: 'create',
    subject: 'budget'
  }
]

export const pilotageAbility = [
  {
    action: 'read',
    subject: 'pilotage'
  },
  {
    action: 'create',
    subject: 'pilotage'
  }
]

// The four menus of the company data, each opened by its own right, read and write ("W") or read only ("R") :
// the screens themselves lock what the user only reads (isMenuReadOnly, public/common.js)
const companyDataAbility = (subject) => [
  {
    action: 'read',
    subject
  },
  {
    action: 'read',
    subject: 'data'
  }
]

export const organizationAbility = companyDataAbility('organization')
export const companyAbility = companyDataAbility('company')
export const populationAbility = companyDataAbility('population')
export const jobPositionAbility = companyDataAbility('jobposition')

export const payTransparencyAbility = [
  {
    action: 'read',
    subject: 'payTransparency'
  }
]

// Abilities given by each access right of comm_user.profile (the boxes of the Users screen, public/users.js)
const abilitiesOfRight = {
  Adm: [...adminAbility, ...ratesAbility],
  Acqu: [...acquireAbility, ...ratesAbility],
  Ref: [...repositoryAbility, ...ratesAbility],
  Conf: [...configurationAbility, ...ratesAbility],
  Sup: supportAbility,
  Empl: employeesAbility,
  // the employee profiles reach the same menu as the full right, and see the zones the client chose for them
  // only (the employee screen restricts itself, isEmployeeFileZoneAllowed in public/common.js)
  Mng: employeesAbility,
  Cdg: employeesAbility,
  OrgW: organizationAbility,
  OrgR: organizationAbility,
  SocW: companyAbility,
  SocR: companyAbility,
  PopW: populationAbility,
  PopR: populationAbility,
  PosW: jobPositionAbility,
  PosR: jobPositionAbility,
  // the right on the four menus before they were each given their own (users not updated since)
  Com: [...organizationAbility, ...companyAbility, ...populationAbility, ...jobPositionAbility],
  Ana: analyticAbility,
  Fore: forecastAbility,
  Bud: budgetAbility,
  Blec: budgetAbility,
  Pro: budgetAbility,
  Pil: pilotageAbility,
  Trans: payTransparencyAbility
}

// Abilities of a user, from his profile : one token per right, each ended by a "§" ("Adm§Ref§Empl§"). Shared by
// the two ways of logging in (Login, SSOCallback)
export const abilitiesOfProfile = (profile) => {
  const abilities = [...basicAbility]
  for (const right of (profile || '').split('§')) {
    if (Object.prototype.hasOwnProperty.call(abilitiesOfRight, right)) abilities.push(...abilitiesOfRight[right])
  }
  return abilities
}